export class ParametroCartaCredito {

    multiplicadorSudanSudeneCentroOeste: number;
    multiplicadorSudanSudeneCentroOesteTecnac: number;
    multiplicadorDemaisRegioes: number;
    multiplicadorDemaisRegioesTecnac: number;
    percentualSudanSudeneCentroOeste: number;
    percentualSudanSudeneCentroOesteTecnac: number;
    percentualDemaisRegioes: number;
    percentualDemaisRegioesTecnac: number;
    multiplicadorPadis: number;
    percentualPadis: number;
    denominadorPdicSudanSudeneCentroOeste: number;
    denominadorPdicDemaisRegioes: number;

}
